var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 400,
    viewBox: "0 0 390 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47215 26.7615L12.0086 17.274L20.6432 25.7406L48.0492 -1.70036V-1.7345H-6.74927V35.8276L20.65 63.4807L48.0492 35.8276V17.3716L20.6497 44.7711L2.47215 26.7615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8864 26.7615L97.4229 17.274L106.057 25.7406L133.463 -1.69993V-1.7345H78.6646V35.8276L106.064 63.4807L133.463 35.8276V17.372L106.064 44.7711L87.8864 26.7615Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.301 26.7615L182.837 17.274L191.472 25.7406L218.877 -1.69999V-1.7345H164.079V35.8276L191.478 63.4807L218.877 35.8276V17.372L191.478 44.7711L173.301 26.7615Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.715 26.7615L268.251 17.274L276.886 25.7406L304.291 -1.6998V-1.7345H249.493V35.8276L276.892 63.4807L304.291 35.8276V17.3722L276.892 44.7711L258.715 26.7615Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.129 26.7615L353.666 17.274L362.3 25.7405L389.706 -1.69983V-1.73456H334.907V35.8275L362.306 63.4807L389.706 35.8275V17.3721L362.307 44.771L344.129 26.7615Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47255 122.592L12.009 113.105L20.6436 121.571L48.0492 94.131V94.0965H-6.74927V131.659L20.65 159.312L48.0492 131.659V113.203L20.6501 140.602L2.47255 122.592Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.886 122.592L97.4225 113.105L106.057 121.571L133.463 94.1306V94.0965H78.6646V131.659L106.064 159.312L133.463 131.659V113.203L106.064 140.602L87.886 122.592Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.301 122.592L182.837 113.105L191.472 121.571L218.877 94.1309V94.0965H164.079V131.659L191.478 159.312L218.877 131.659V113.203L191.478 140.602L173.301 122.592Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.715 122.592L268.251 113.105L276.886 121.571L304.291 94.1311V94.0965H249.493V131.659L276.892 159.312L304.291 131.659V113.203L276.892 140.602L258.715 122.592Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.129 122.592L353.666 113.105L362.3 121.571L389.706 94.1311V94.0965H334.907V131.659L362.306 159.312L389.706 131.659V113.203L362.307 140.602L344.129 122.592Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47255 218.423L12.009 208.936L20.6436 217.402L48.0492 189.962V189.927H-6.74927V227.489L20.65 255.142L48.0492 227.489V209.034L20.6501 236.433L2.47255 218.423Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8864 218.423L97.4229 208.936L106.057 217.402L133.463 189.962V189.927H78.6646V227.489L106.064 255.142L133.463 227.489V209.034L106.064 236.433L87.8864 218.423Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.3 218.423L182.837 208.936L191.471 217.402L218.877 189.961V189.927H164.079V227.489L191.478 255.142L218.877 227.489V209.033L191.478 236.433L173.3 218.423Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.715 218.423L268.251 208.936L276.886 217.402L304.291 189.962V189.927H249.493V227.489L276.892 255.142L304.291 227.489V209.034L276.892 236.433L258.715 218.423Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.129 218.423L353.666 208.936L362.3 217.402L389.706 189.962V189.927H334.907V227.489L362.306 255.142L389.706 227.489V209.034L362.307 236.433L344.129 218.423Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47255 314.254L12.009 304.767L20.6436 313.233L48.0492 285.793V285.758H-6.74927V323.32L20.65 350.974L48.0492 323.32V304.865L20.6501 332.264L2.47255 314.254Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8864 314.254L97.4229 304.767L106.057 313.233L133.463 285.793V285.758H78.6646V323.32L106.064 350.974L133.463 323.32V304.865L106.064 332.264L87.8864 314.254Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.301 314.255L182.837 304.767L191.472 313.234L218.877 285.793V285.758H164.079V323.32L191.478 350.974L218.877 323.32V304.865L191.478 332.264L173.301 314.255Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.715 314.255L268.251 304.767L276.886 313.234L304.291 285.793V285.758H249.493V323.32L276.892 350.974L304.291 323.32V304.865L276.892 332.264L258.715 314.255Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.129 314.255L353.666 304.767L362.3 313.234L389.706 285.793V285.758H334.907V323.32L362.306 350.974L389.706 323.32V304.865L362.307 332.264L344.129 314.255Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47255 410.085L12.009 400.598L20.6436 409.064L48.0492 381.624V381.589H-6.74927V419.151L20.65 446.804L48.0492 419.151V400.696L20.6501 428.095L2.47255 410.085Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8864 410.085L97.4229 400.598L106.057 409.064L133.463 381.624V381.589H78.6646V419.151L106.064 446.804L133.463 419.151V400.696L106.064 428.095L87.8864 410.085Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.301 410.085L182.837 400.598L191.472 409.064L218.877 381.624V381.589H164.079V419.151L191.478 446.804L218.877 419.151V400.696L191.478 428.095L173.301 410.085Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.715 410.085L268.251 400.598L276.886 409.064L304.291 381.624V381.589H249.493V419.151L276.892 446.804L304.291 419.151V400.696L276.892 428.095L258.715 410.085Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.129 410.085L353.665 400.598L362.3 409.064L389.706 381.624V381.589H334.907V419.151L362.306 446.804L389.706 419.151V400.696L362.306 428.095L344.129 410.085Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPattern);
export default __webpack_public_path__ + "static/media/background-pattern.ef7d7390f25f8cfbf63176848e8a0670.svg";
export { ForwardRef as ReactComponent };